const langIt_arca_famila = {
  "df-router-title-page-recipes": "La tua ricetta",
  "df-section-recipes.title": "La tua ricetta",
  "df-page-recipes.title": "La tua ricetta",
};

export default langIt_arca_famila;
